export default __webpack_public_path__ + "static/utterberry-b98856e02e45b7f1ca0750cb2b5c15a4.webp";